__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "mycorvinus_navigator";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hookstate/core", "3.0.13", () => (__webpack_require__.e(2307).then(() => (() => (__webpack_require__(12307))))));
			register("@material-ui/core", "4.12.3", () => (Promise.all([__webpack_require__.e(868), __webpack_require__.e(2335), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(42335))))));
			register("dompurify", "2.3.3", () => (__webpack_require__.e(7856).then(() => (() => (__webpack_require__(27856))))));
			register("lodash.debounce", "4.0.8", () => (__webpack_require__.e(1296).then(() => (() => (__webpack_require__(91296))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(6486).then(() => (() => (__webpack_require__(96486))))));
			register("lottie-react", "2.3.1", () => (__webpack_require__.e(9260).then(() => (() => (__webpack_require__(69260))))));
			register("react-calendar", "3.5.0", () => (__webpack_require__.e(73).then(() => (() => (__webpack_require__(73))))));
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(73935))), 1);
			register("react-router-dom", "5.3.0", () => (() => (__webpack_require__(23338))), 1);
			register("react-xarrows", "2.0.2", () => (Promise.all([__webpack_require__.e(1420), __webpack_require__.e(4439)]).then(() => (() => (__webpack_require__(91420))))));
			register("react", "17.0.2", () => (() => (__webpack_require__(67294))), 1);
			register("recharts", "2.1.6", () => (Promise.all([__webpack_require__.e(1371), __webpack_require__.e(3390), __webpack_require__.e(328)]).then(() => (() => (__webpack_require__(81371))))));
			register("semantic-ui-react", "2.0.4", () => (Promise.all([__webpack_require__.e(3291), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(13291))))));
			initExternal(89327);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};